import React, { useState, useEffect } from 'react';
import "./productSets.css";
import { useSelector, useDispatch } from "react-redux";
import { campaignListActions } from '../../redux/slices/campaignList';
import {masterApi} from '../../apis/masterApi'
import {encodeData} from '../../helper/common/encodeData'
import { formatDateFn } from '../../helper/common/formatDateForAPI';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { useGlobalContext } from '../../context/global';
import StopLossLogsModal from '../StopLossList/subComponents/StopLossLogsModal/StopLossLogsModal';
import { toast } from 'react-toastify';
import useUserDetails from '../../helper/userData/useUserDetails';
import { PRODUCT_SET_LIST_DATAHEADS } from '../../constant/productset/productsetconfig';
import MasterTagetinngActionAlertMModal from '../../components/modal/masterTargetinngActionnAlertMModal/masterTargetingActionnAlertModal';
import { PlatformWiseKeyMapper } from '../../components/Filter/FilterData/quadrantFilter';
import moment from 'moment/moment';
import PlatformFetchStatus from '../../components/PlatformFetchStatus/PlatformFetchStatus';
import MyntraIcon from "../../assets/svgs/myntra.svg";
import { isPlatformMatch } from '../../helper/Reports/common';
import { formatDate } from '../../components/Reports/Components/utils';
import { PerformanceAnalysisMeasures } from '../PerformanceAnalysis/performanceAnalysisConfigs';
import {
  IconButton,
  Typography,
  Box,
  TextField,
  Button,
  InputAdornment,
} from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import CloseIcon from "@mui/icons-material/Close";
import AddIcon from "@mui/icons-material/Add";
import Header from '../../components/header/header';
import SmartAdsTable from './subComponents/SmartAdsTable';
import CampaignMappingModal from './subComponents/CampaignMappingModal';


const ProductSetsList = () => {

    const dashboardSideBarVisibiltyState = useSelector(
        (state) => state.dashboardData.dashboardSideBarVisibiltyState
    );
    const filterModalInCampaignListVisibilty = useSelector(
        (state) => state.campaignListData.filterModalInCampaignListVisibilty
    );
    const appliedFilterData = useSelector((state) => state?.campaignListData?.appliedFilterData)
    const userPlatform = JSON.parse(localStorage.getItem("user_platform"));

    const metricesWithTwoDecimalPlaces = [
        "cpm",
        "cpc",
        "roas",
        "acos",
        "ctr",
        "cvr",
    ];
    const [allFetchLoaders, setAllFetchLoaders] = useState({
        mainPageLoader: true,
        campaignStatsLoader: false,
        campaignAdsetsLoader: false,
        campaignAdsetStatsLoader: false,
    });
    const [dataHeads, setdataHeads] = useState(PRODUCT_SET_LIST_DATAHEADS[userPlatform]);
    const [selectedRow, setSelectedRow] = useState({});
    const [isFilterVisible, setIsFilterVisible] = useState(false);
    const [lastFetchedAt, setLastFetchedAt] = useState("");
    const [showAlertMsgOf,setShowAlertMsgOf] = useState(`To enable or pause a Product Set, click on 'Proceed'—you will be redirected to the ${userPlatform} dashboard, where you can complete the action manually.`)
    
    const fakeDataForStats =   [
        // {
        //     "clicks": 0,
        //     "impressions": 149,
        //     "orders": 0,
        //     "cpm": 0,
        //     "ctr": 0,
        //     "spends": 11,
        //     "sale_value": 0,
        //     "campaign_name": "SDPT | Deco01 & Mini7 | Conversions",
        //     "campaign_id": "119018735890223",
        //     "adset_id": "324394477510965"
        // },
    ]
    const [productSets,setProductSets] = useState([])
    const [creatives,setCreatives] = useState([])
    const [adsets,setAdsets] = useState([])
    const [campaigns,setCampaigns] = useState([])
    const [stats,setStats] = useState(fakeDataForStats)
    const [userDetails] = useUserDetails();
    const [summaryData, setSummaryData] = useState([]);
    const [allData, setAllData] = useState([]);
    const [searchValue, setSearchValue] = useState("");
    const [showMappingModal, setShowMappingModal] = useState(false);
    const [selectedRowForMapping, setSelectedRowForMapping] = useState(null);
    const [productSetSortOrder, setProductSetSortOrder] = useState("DESC");
    const [searchfilteredData, setsearchfilteredData] = useState([
        // {
        //     "id": "6400345c3c2cb56a78765866",
        //     "product_set": "ADYG_Women_Kurtha",
        //     "spends": "200",
        //     "spends_delta": "10",
        //     "revenue": "101",
        //     "revenue_delta": "10",
        //     "roas": "21",
        //     "roas_delta": "10",
        //     "campaignStat":
        //         [
        //             {
        //                 "active_campaigns": 6674,
        //                 "active_adgroups": 28,
        //                 "refresh_frequency": 4,
        //                 "type": "Dynamic",
        //                 "orders": 332,
        //                 "cpm": 6.315174840467556,
        //                 "ctr": 0.3287185983604458,
        //                 "cpc": 1.9211492358405757,
        //                 "cvr": 0.7042253521126761,
        //                 "aov": 453.31702127659577,
        //                 "roas": 1.6616998459648642,
        //                 "revenue": 60.17933999502486,
        //                 "spends": 12821.750000000002,
        //                 "sale_value": 21305.9,
        //                 "campaign_id": "228155303657618",
        //                 "spends_delta": "10",
        //                 "revenue_delta": "10",
        //                 "roas_delta": "10",
        //             }
        //         ]
        // },
    ]);
    const {calendarDate,applyCalendar,clientId,clientData} = useGlobalContext()
   
    const dispatch = useDispatch();

    const [showLogsModal,setShowLogsModal] = useState('')
    const [productSetName,setProductSetName] = useState('')
    const navigate = useNavigate();

    const openMyntraFlipkartDashboardLink = () => {
        const { campaign_id } = selectedRow || {};
        const setup = userPlatform === 'myntra' ? clientData?.myntra_setup : clientData?.flipkart_setup;
        const { b_account, profile_id: aaccount } = setup || {};
      
        if (!campaign_id || !b_account || !aaccount) {
          toast.error("Campaign ID not found for this product set.");
          return;
        }
      
        const urls = {
          myntra: `https://advertising.myntra.com/ad-user/manage-campaign/${campaign_id}?businessAccountId=${b_account}&adAccountId=${aaccount}`,
          flipkart: `https://advertising.flipkart.com/ad-account/campaigns/pla/${campaign_id}?baccount=${b_account}&aaccount=${aaccount}&campaign=${campaign_id}&hierarchy=10&tab=0`
        };
      
        const url = urls[userPlatform];
        window.open(url, '_blank', 'noopener,noreferrer');
      };

      function capitalizeFirstLetter(string) {
        if (!string) return "";
        return string.charAt(0).toUpperCase() + string.slice(1);
      }
      
    const getProductSetListUrl = (client_id, sortingOrder = productSetSortOrder) =>
      `${process.env.REACT_APP_ADS_API}/client/${client_id}/product-set?source=${userPlatform}&categories&order_by=createdAt&sorting_order=${sortingOrder}`;

    const fetchMainDataOfCampaigns = async (sortingOrder = productSetSortOrder) => {
        // This function will fetch data one by one and set into respective stats.
        const client_id =  JSON.parse(localStorage.getItem("clientId"));
        try {
            // API Call:- All Product Sets
            setAllFetchLoaders({...allFetchLoaders,mainPageLoader:true})
            const urlForAllProductSets = getProductSetListUrl(client_id, sortingOrder)
            const allProductSets = await axios.get(urlForAllProductSets)
            setProductSets([...allProductSets?.data ?? []])
            // Id's For Passing in Next API Call
            const allProductSetsIds = allProductSets?.data?.map((productSet) => productSet?.id)
            // API Call :- All creatives
            const filteringForCreatives = [{"field_name": "product_set_id","operator": "IN","values":allProductSetsIds}]
            const dataForCreatives = {
                source: `${userPlatform}`,
                type:`${PlatformWiseKeyMapper?.[userPlatform]?.productSetCreativeType}`,
                filtering: encodeData(filteringForCreatives)
            }
            const result = await masterApi(dataForCreatives,"Adset",false)
            setCreatives([...result?.data?.data ?? []])
            const allCreativesAdsetId = result?.data?.data?.map((data) => data?.adset_id)

            const filteringForAdsets = [{"field_name": "id","operator": "IN","values":allCreativesAdsetId}]
            const dataForPlatformIds = {
                source: `${userPlatform}`,
                limit:5000,
                fields:"platform_id,id",
                filtering: encodeData(filteringForAdsets)
            }
            // API Call For All Adsets
            const allPlatformIds = await masterApi(dataForPlatformIds,"adsetList",false)
            const allIds = allPlatformIds?.data?.data?.map((platform) => Number(platform?.platform_id));
            setAdsets([...allPlatformIds?.data?.data ?? []])
            const filteringForStats = [ { "field_name": "adset_id", "operator": "IN", "values": [...allIds] }]
            const dataForGettingStats = {
                level:"adset",
                platform: `${userPlatform}`,
                start_date:`${formatDateFn(calendarDate[0].startDate)}`,
                end_date:`${formatDateFn(calendarDate[0].endDate)}`,
                fields:'campaign_id,adset_id,spends,roas,clicks,campaign_name,orders,sale_value,impressions,cpc,cvr,aov,acos,cpm,orders,ctr',
                group_by:"adset_id",
                filtering:encodeData(filteringForStats)
            }

            // API call for Main Stats
            const mainStatsData = await masterApi(dataForGettingStats,"masterApi");
            setStats([...mainStatsData?.data?.data ?? []]);

            // summary data using adset id
              const dataForGettingSummaryStats = {
                level:"adset",
                platform: `${userPlatform}`,
                start_date:`${formatDateFn(calendarDate[0].startDate)}`,
                end_date:`${formatDateFn(calendarDate[0].endDate)}`,
                fields:'campaign_id,adset_id,spends,roas,clicks,campaign_name,orders,sale_value,impressions,cpc,cvr,aov,acos,cpm,orders,ctr',
                filtering:encodeData(filteringForStats)
            }
            // API call for Main Stats
            const mainSummaryStatsData = await masterApi(dataForGettingSummaryStats,"masterApi");
            setSummaryData([...mainSummaryStatsData?.data?.data ?? []])
        } catch (error) {
            console.log(error)
        } finally {
            setAllFetchLoaders({...allFetchLoaders,mainPageLoader:false})

        }
    }
 
    function consolidateData (productSetList,creatives,adsets,stats) {
        const mainStats = [...productSetList]?.map((data) => {
            const {name,refresh_duration,id,created_at,status} = data
            const refreshFreq = refresh_duration.match(/\d+/g);
            const creative = creatives?.find((creativeEl) => creativeEl?.product_set_id === data?.id);
            const adset = adsets?.find((adset) => adset?.id === creative?.adset_id);
            const stat = stats?.find((stat) => stat?.adset_id === adset?.platform_id);
            let adset_id = adset?.platform_id;
            let statsForEachObject =  {
                "refresh_frequency": refreshFreq,
                "type": "Dynamic",
                "adset_id": adset_id,
            };
            if(stat) {
                statsForEachObject = {...statsForEachObject,...stat}
            }
            return  {
                "id": id,
                "status":status ?? false,
                "product_set": name,
                "creation_date":created_at,
                "created_at": created_at,
                entity_populate_list: data?.entity_populate_list,
                "campaignStat":
                    [
                        {
                          ...statsForEachObject,
                          created_at,
                        }
                    ]
            }
        })
        return mainStats
    }

    // Myntra logic to fetch data start
    const fetchMainDataOfCampaignsMyntra = async (sortingOrder = productSetSortOrder) => {
        // This function will fetch data one by one and set into respective stats.
        const client_id =  JSON.parse(localStorage.getItem("clientId"));
        try {
            // API Call:- All Product Sets
            setAllFetchLoaders({...allFetchLoaders,mainPageLoader:true})
            const urlForAllProductSets = getProductSetListUrl(client_id, sortingOrder)
            const allProductSets = await axios.get(urlForAllProductSets)
            setProductSets([...allProductSets?.data ?? []])
            const sortedProductSetOnUpdated = sortDataByCreationDate(allProductSets?.data?.filter(item => !!item?.is_modified_by_back_sync),'desc','updated_at');
            setLastFetchedAt( sortedProductSetOnUpdated?.[0]?.updated_at ? `${moment(sortedProductSetOnUpdated?.[0]?.updated_at).utcOffset("+05:30").format("DD MMM YYYY, hh:mm a")}` : '-');
            // Id's For Passing in Next API Call
            const allMongoAdsetId = allProductSets?.data?.map((productSet) => productSet?.entity_populate_list?.[0]?.adset_id)
            const allMongoCampaignId = allProductSets?.data?.map((productSet) => productSet?.entity_populate_list?.[0]?.campaign_id)
          
            const filteringForAdsets = [{"field_name": "id","operator": "IN","values":allMongoAdsetId}]
            const dataForPlatformIds = {
                source: `${userPlatform}`,
                limit:5000,
                fields:"platform_id,id",
                filtering: encodeData(filteringForAdsets)
            }
            // API Call For All Adsets
            const allRawAdsetIds = await masterApi(dataForPlatformIds,"adsetList",false)
            setAdsets([...allRawAdsetIds?.data?.data ?? []])

            const allAdsetPlatformIds = allRawAdsetIds?.data?.data?.map((platform) => platform?.platform_id);
            const filteringForCampaignIds = [{"field_name": "id","operator": "IN","values":allMongoCampaignId}]
            const dataForPlatformCampaginIds = {
                source: `${userPlatform}`,
                limit:5000,
                fields:"platform_id,id",
                filtering: encodeData(filteringForCampaignIds)
            }
            // API Call For All campaigns
            const allPlatformCampaignIds = await masterApi(dataForPlatformCampaginIds,"campaignList",false)
            setCampaigns([...allPlatformCampaignIds?.data?.data ?? []]);

            if(userPlatform !== "flipkart"){
            const filteringForStats = [ { "field_name": "ad_group_id", "operator": "IN", "values": [...allAdsetPlatformIds] }]
            const dataForGettingStats = {
                level:"adset",
                platform: `${userPlatform}`,
                start_date:`${formatDateFn(calendarDate[0].startDate)}`,
                end_date:`${formatDateFn(calendarDate[0].endDate)}`,
                fields:'campaign_id,ad_group_id,spends,impressions,views,clicks,ctr,cpc,cvr,units_sold_direct,units_sold_indirect,orders,revenue_direct,revenue_indirect,revenue,direct_roas,roas',
                group_by:"ad_group_id",
                filtering:encodeData(filteringForStats)
            }
            // API call for Main Stats
            const mainStatsData = await masterApi(dataForGettingStats,"masterApi");
            const mappedMainStatsData = mainStatsData?.data?.data?.map((stat) => {
                return {
                    ...stat,
                    adset_id: stat?.ad_group_id,
                }
            });
            setStats([...mappedMainStatsData ?? []])
            // summary data using adset id
            const dataForGettingSummaryStats = {
                level:"adset",
                platform: `${userPlatform}`,
                start_date:`${formatDateFn(calendarDate[0].startDate)}`,
                end_date:`${formatDateFn(calendarDate[0].endDate)}`,
                fields:'campaign_id,ad_group_id,spends,impressions,views,clicks,ctr,cpc,cvr,units_sold_direct,units_sold_indirect,orders,revenue_direct,revenue_indirect,revenue,direct_roas,roas',
                filtering:encodeData(filteringForStats)
            }
            // API call for Main Stats
            const mainSummaryStatsData = await masterApi(dataForGettingSummaryStats,"masterApi");
            setSummaryData([...mainSummaryStatsData?.data?.data ?? []])
            } else if (userPlatform === "flipkart") {
            // Flipkart: fetch stats via placement insights API with dimension product_set_id
            const allProductSetsIds = allProductSets?.data?.map((ps) => ps?.id)?.filter(Boolean) ?? [];
            const placementInsightsUrl = `${process.env.REACT_APP_REPORT_API}/client/${client_id}/placement:insights?source=flipkart`;
            const flipkartMeasures = PerformanceAnalysisMeasures?.flipkart ?? [
              "clicks", "spends", "ctr", "cvr", "revenue", "roas", "cpc", "impressions", "orders", "cpm", "aov", "acos",
            ];
            const queryData = {
              dimensions: ["product_set_id"],
              filters: allProductSetsIds.length > 0
                ? {"dimensions":{
                  type: "AND_RULE",
                  and: [
                    {
                      type: "RULE_ITEM",
                      member: "product_set_id",
                      operator: "in",
                      values: allProductSetsIds,
                    },
                  ],
                }}
                : {},
              extra_filters: {
                type: "flipkart"
              },
              percentile_filters: [],
              measures: ["product_set_id", ...flipkartMeasures],
              order: [["product_set_id", "asc"]],
              date_preset: null,
              timeDimensions: [
                {
                  dimension: PlatformWiseKeyMapper[userPlatform]?.date ?? "date",
                  dateRange: [
                    formatDate(calendarDate[0].startDate),
                    formatDate(calendarDate[0].endDate),
                  ],
                },
              ],
              offset: 0,
              limit: Math.max(allProductSetsIds.length || 1, 5000),
            };
            const { data: placementResponse } = await axios.post(placementInsightsUrl, { query: queryData });
            const placementData = placementResponse?.data ?? [];
            // Map to stats array by product_set_id; align revenue -> sale_value for table
            const mappedStats = (placementData || []).map((row) => ({
              ...row,
              product_set_id: row?.product_set_id,
              sale_value: row?.sale_value ?? row?.revenue,
            }));
            setStats([...mappedStats]);

            // Flipkart: fetch summary from placement insights-summary with same payload
            const placementSummaryUrl = `${process.env.REACT_APP_REPORT_API}/client/${client_id}/placement:insights-summary?source=flipkart`;
            const { data: summaryResponse } = await axios.post(placementSummaryUrl, { query: queryData });
            const summaryPayload = summaryResponse?.data ?? summaryResponse;
            setSummaryData(Array.isArray(summaryPayload) ? summaryPayload : (summaryPayload != null ? [summaryPayload] : []));
            }
           
        } catch (error) {
            console.log(error)
        } finally {
            setAllFetchLoaders({...allFetchLoaders,mainPageLoader:false})
        }
    }
 
    function consolidateDataMyntra (productSetList,campaigns,adsets,stats) {
        const mainStats = [...productSetList]?.map((data) => {
            const {name,refresh_duration,id,created_at,status} = data
            const refreshFreq = refresh_duration?.match(/\d+/g);
            const adset = adsets?.find((adset) => adset?.id === data?.entity_populate_list?.[0]?.adset_id);
            const campaign = campaigns?.find((campaign) => campaign?.id === data?.entity_populate_list?.[0]?.campaign_id);
            const stat = userPlatform === "flipkart"
                ? stats?.find((s) => String(s?.product_set_id) === String(id))
                : stats?.find((s) => s?.adset_id === adset?.platform_id);
            let statsForEachObject =  {
                "refresh_frequency": refreshFreq,
                "type": "Dynamic",
                "adset_id": adset?.platform_id,
                "campaign_id": campaign?.platform_id,
            };
            if(stat) {
                statsForEachObject = {...statsForEachObject,...stat}
            }
            return  {
                "id": id,
                "status":status ?? false,
                "product_set": name,
                "creation_date":created_at,
                "created_at": created_at,
                entity_populate_list: data?.entity_populate_list,
                "campaignStat":
                    [
                        {
                          ...statsForEachObject,
                          created_at,
                        }
                    ]
            }
        })
        return mainStats
    }
    // Myntra logic to fetch data end

    const onShortBtnClickHandler = (value, order = "desc") => {
      if (value === "created_at") {
        const apiOrder = order?.toUpperCase() === "ASC" ? "ASC" : "DESC";
        setProductSetSortOrder(apiOrder);
        if (isPlatformMatch(["myntra", "flipkart"])) {
          fetchMainDataOfCampaignsMyntra(apiOrder);
        } else {
          fetchMainDataOfCampaigns(apiOrder);
        }
        return;
      }

      const sortedData = [...searchfilteredData];
      const key = value === "REVENUE" ? "sale_value" : value;
      sortedData.sort((a, b) => {
        const aValue = a?.campaignStat?.[0]?.[key] ?? 0;
        const bValue = b?.campaignStat?.[0]?.[key] ?? 0;

        return order === "asc" ? aValue - bValue : bValue - aValue;
      });
      setsearchfilteredData(sortedData);
    };

    useEffect(() => {
        if(isPlatformMatch(["myntra", "flipkart"])) {
            fetchMainDataOfCampaignsMyntra()
        } else {
        fetchMainDataOfCampaigns()
        }
    },[applyCalendar])

    function sortDataByCreationDate(data, order = 'asc',key='creation_date') {
        return data?.sort((a, b) => {
            const dateA = a[key] ? new Date(a[key]) : null;
            const dateB = b[key] ? new Date(b[key]) : null;
    
           
        if (!dateA && !dateB) {
            return 0;
        } else if (!dateA) {
            return 1; // dateA is null, so a should be pushed to the end
        } else if (!dateB) {
            return -1; // dateB is null, so b should be pushed to the end
        } else {
            return order === 'asc' ? dateA - dateB : dateB - dateA;
        }
        });
    }

    useEffect(() => {
        if(isPlatformMatch(["myntra", "flipkart"])) {
            const mainData = consolidateDataMyntra(productSets,campaigns,adsets,stats)
            setAllData([...mainData])
            return
        }else{
            const mainData = consolidateData(productSets,creatives,adsets,stats)
            setAllData([...mainData])
        }

    },[stats,creatives,productSets,adsets,campaigns,appliedFilterData])

  
    const handleRedirectForUpdate = (dataId,dataIndex) => {
        const url = `/product-analytics?reportType=child_product&viewtype=PERFORMANCE&page=productset&productsetId=${dataId}`;
        navigate(url);
    }

    async function  handleUpdateCheckedData (id) {
        id = id || selectedRow?.id;
        try {
            setAllFetchLoaders({...allFetchLoaders,mainPageLoader:true});
            const mainFoundedData = searchfilteredData?.find((data) => data?.id === id)
            if(!mainFoundedData) {
                return
            }
            const status =  mainFoundedData['status'] === 'ENABLED' ? 'PAUSED' : 'ENABLED'
            const formattedData = {
                modified_by:userDetails?.user?.email,
                status:status,
                id
            }
            const url = `${process.env.REACT_APP_ADS_API}/client/${clientId}/product-set/${id}?source=${userPlatform}`
            const data = await axios.patch(url,formattedData,{headers:{
                'Content-Type':'application/merge-patch+json'
              }})
            if(data?.data?.id) {
                toast.success('Product set updated successfully!')
                setAllData((prev) => {
                    return [...prev]?.map((data) => {
                        if(data?.id === id) {
                            data.status = status
                        }
                        return {...data}
                    })
                })
            }
            setAllFetchLoaders({...allFetchLoaders,mainPageLoader:false});
        } catch (error) {
            setAllFetchLoaders({...allFetchLoaders,mainPageLoader:false});
            const message = error?.response?.status!==200 ? error?.response?.data?.message : error?.message
            toast.error(message ?? 'Some unknown error occurred!')
        }
    }

    

    useEffect(() => {
        setIsFilterVisible(filterModalInCampaignListVisibilty);
    }, [filterModalInCampaignListVisibilty]);

    useEffect(() => {
  if (searchValue.trim() === "") {
    setsearchfilteredData(allData);
  } else {
    const filtered = allData.filter((item) =>
      item.product_set?.toLowerCase().includes(searchValue.toLowerCase())
    );
    setsearchfilteredData(filtered);
  }
}, [searchValue, allData]);

    return (
      <div
        className={
          dashboardSideBarVisibiltyState
            ? "main-content-container-onopen-mode"
            : "main-content-container-oncolapse-mode"
        }
        id="main-box"
      >
        {/* Header Section */}
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            mb: 3,
          }}
        >
          <Box>
            <Box sx={{ display: "flex", alignItems: "center", gap: 0.5 }}>
              <Typography variant="h6" fontWeight={600}>
                Product Set List
              </Typography>
              <PlatformFetchStatus
                fetchedDataStatus={[
                  {
                    name: "Myntra",
                    icon: MyntraIcon,
                    lastFetch: lastFetchedAt,
                    error: lastFetchedAt === "-",
                    platform: "myntra",
                  },
                ]}
                type="API"
              />
            </Box>
            <Typography variant="body2" color="text.secondary">
              This page indicates all the product ads launched on{" "}
              {capitalizeFirstLetter(userPlatform)}
            </Typography>
          </Box>
           
          <Button
            onClick={() =>
              navigate(
                "/product-analytics?reportType=child_product&viewtype=PERFORMANCE&page=productset"
              )
            }
            variant="contained"
            startIcon={<AddIcon />}
            sx={{
              borderRadius: "8px",
              textTransform: "none",
              backgroundColor: "#6759FF",
              boxShadow: "none",
              "&:hover": {
                boxShadow: "none",
              },
            }}
          >
            Create New Product Set
          </Button>
        </Box>

        {/* Filters */}
        <Box sx={{ display: "flex", justifyContent: "space-between", mb: 2 }}>
          <TextField
            size="small"
            placeholder="Search Product Set"
            variant="outlined"
            value={searchValue}
            onChange={(e) => setSearchValue(e.target.value)}
            sx={{
              width: "calc(100% - 180px)",
              "& .MuiInputBase-input::placeholder": {
                color: "#666666",
                opacity: 1,
              },
            }}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <SearchIcon fontSize="small" />
                </InputAdornment>
              ),
              endAdornment: searchValue && (
                <InputAdornment position="end">
                  <IconButton
                    size="small"
                    onClick={() => setSearchValue("")}
                    edge="end"
                  >
                    <CloseIcon fontSize="small" />
                  </IconButton>
                </InputAdornment>
              ),
            }}
          />
          <Header showOnlyCalendar={true} />
        </Box>
        <div>
          {
            <StopLossLogsModal
              productSetName={productSetName}
              showLogsModal={showLogsModal}
              setShowLogsModal={setShowLogsModal}
              pageName="productset"
            />
          }

          <div className="campaign-list-table-data">
            <SmartAdsTable
              dataHeads={dataHeads}
              searchfilteredData={searchfilteredData}
              allFetchLoaders={allFetchLoaders}
              onSortClick={onShortBtnClickHandler}
              handleEdit={(id) => handleRedirectForUpdate(id)}
              handleCampaignMapping={(data) => {
                setSelectedRowForMapping(data);
              }}
              handleLogs={(id, productSetName = "") => {
                setShowLogsModal(id);
                setProductSetName(productSetName);
              }}
              handleSwitchChange={(row) => {
                if (isPlatformMatch(["myntra", "flipkart"])) {
                  dispatch(campaignListActions.showActionAlertModal());
                  setSelectedRow({
                    id: row.id,
                    adset_id: row?.campaignStat?.[0]?.adset_id,
                    campaign_id: row?.campaignStat?.[0]?.campaign_id,
                  });
                } else {
                  handleUpdateCheckedData(row.id);
                }
              }}
              summaryData={summaryData}
            />
          </div>
        </div>
        {showAlertMsgOf !== "" && (
          <MasterTagetinngActionAlertMModal
            alertText={showAlertMsgOf}
            // alertInfo={""}
            onYesClick={() => {
              // open external link in a new tab
              openMyntraFlipkartDashboardLink();
            }}
            onNoClick={() => {}}
            confirmationId={"pause-adset-confirm"}
            yesBtnText={"Proceed"}
            noBtnText={"Cancel"}
          ></MasterTagetinngActionAlertMModal>
        )}
        <CampaignMappingModal
          key={selectedRowForMapping?.id || ""}
          open={!!selectedRowForMapping}
          onClose={() => {
            setSelectedRowForMapping(null);
            setShowMappingModal(false);
          }}
          onRefetch={() => {
            if (isPlatformMatch(["myntra", "flipkart"])) {
              fetchMainDataOfCampaignsMyntra(productSetSortOrder);
            } else {
              fetchMainDataOfCampaigns(productSetSortOrder);
            }
          }}
          userPlatform={userPlatform}
          productsetId={selectedRowForMapping?.id || ""}
          entity_populate_list={
            selectedRowForMapping?.entity_populate_list || []
          }
        />
      </div>
    );
}

export default ProductSetsList;
